(() => {
  if (window.__tmhMotionReady) return;
  window.__tmhMotionReady = true;
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const selectors = [
    '.tmh-section', '.tmh-editorial', '.tmh-promises', '.tmh-lower',
    '.tmh-collection-head', '.tmh-collection-card', '.tmh-product-hero',
    '.tmh-product-story', '.tmh-product-detail-grid', '.tmh-product-accordions',
    '.tmh-editorial-motion', '.tmh-related'
  ];
  const elements = [...document.querySelectorAll(selectors.join(','))];
  if (reduced || !('IntersectionObserver' in window)) {
    elements.forEach((element) => element.classList.add('is-visible'));
    return;
  }
  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-visible');
      observer.unobserve(entry.target);
    });
  }, { rootMargin: '0px 0px -7% 0px', threshold: .06 });
  elements.forEach((element, index) => {
    element.classList.add('tmh-reveal');
    element.style.transitionDelay = `${Math.min(index % 4, 2) * 45}ms`;
    observer.observe(element);
  });
})();
